import Homesatays from "./Homesatays";
import PublicationSuccess from "../Facilities/PublicationSuccess";


const createHomestays = [
    {
        title: 'Введите текст объявления',
        progress: { title: 'Передержка', step: 2 },
        component: Homesatays, valid: true, required: true,
    },
    {
        progress: { title: 'Спасибо', step: 3 },
        component: PublicationSuccess, valid: true, required: true,
    },
];

export default  createHomestays
